import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useCallback } from "react";
import Select from "react-select";
import { withGenericConfig } from "/contexts/generic-config-context";
import { componentStyles } from "./multi-select-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { multiSelectFloatingLabelStyles } from "./multi-select-input-floating-label.scss";
import { Option, MultiValueRemove, ClearIndicator, DropdownIndicator } from "./multi-select-custom-components";
import getReactSelectStyles from "./multi-select-styles";
import classnames from "classnames";
import FloatingLabelWrapper from "../floating-label-wrapper/floating-label-wrapper";
function MultiSelectInputFloatingLabel(props) {
    const { inputData, onInputChange, onInputBlur, value, invalid, errorLabelId, id, translate } = props;
    const { inputName, isRequired, options, defaultValue, isMulti, placeholder, closeMenuOnSelect } = inputData;
    const [isFocused, setIsFocused] = useState(false);
    const getTranslatedOptions = useCallback(()=>{
        return options.map((option)=>({
                label: translate(option.label),
                value: option.value
            }));
    }, [
        options,
        translate
    ]);
    const getTranslatedValue = useCallback(()=>{
        if (!value) {
            return value;
        }
        const translatedOptions = getTranslatedOptions();
        const valueArray = Array.isArray(value) ? value : [
            value
        ];
        return valueArray.map((v)=>translatedOptions.find((opt)=>opt.value === v.value) || v);
    }, [
        value,
        getTranslatedOptions
    ]);
    const onBlur = useCallback(()=>{
        setIsFocused(false);
        onInputBlur({
            target: {
                name: inputName,
                value: value !== null && value !== void 0 ? value : ""
            }
        });
    }, [
        inputName,
        value,
        onInputBlur
    ]);
    const onFocus = useCallback(()=>{
        setIsFocused(true);
    }, []);
    const onChange = useCallback((newValue, action)=>{
        onInputChange({
            target: {
                name: action.name,
                value: newValue
            }
        });
    }, [
        onInputChange
    ]);
    const hasValue = value && (Array.isArray(value) ? value.length > 0 : true);
    const translatedPlaceholder = translate(placeholder);
    const selectInputId = `${id}-input`;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FloatingLabelWrapper, {
                label: translatedPlaceholder,
                htmlFor: selectInputId,
                isFocused: isFocused,
                hasValue: hasValue,
                variant: "select",
                children: /*#__PURE__*/ _jsx(Select, {
                    className: classnames("hp-multi-select-input", {
                        "is-single": !isMulti
                    }),
                    classNamePrefix: "react-select",
                    id: id,
                    inputId: selectInputId,
                    name: inputName,
                    onChange: onChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    defaultValue: defaultValue,
                    options: getTranslatedOptions(),
                    placeholder: "",
                    components: {
                        Option,
                        MultiValueRemove,
                        ClearIndicator,
                        DropdownIndicator
                    },
                    isMulti: isMulti,
                    hideSelectedOptions: false,
                    styles: getReactSelectStyles(invalid),
                    required: isRequired,
                    "aria-label": translatedPlaceholder,
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    isSearchable: false,
                    closeMenuOnSelect: closeMenuOnSelect || false,
                    blurInputOnSelect: false,
                    value: getTranslatedValue()
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: multiSelectFloatingLabelStyles.__hash,
                children: multiSelectFloatingLabelStyles
            })
        ]
    });
}
export default withGenericConfig(MultiSelectInputFloatingLabel);
